<template>
  <div class="cso-input"
       :class="{'is-error': validationErrors || isErrorMessage, 'is-active': isActive, 'is-filled': isFilled || autofilled, 'is-disabled': disabled, 'no-label': !label}">

    <div class="cso-input-wrapper">
      <label v-if="label"
            :for="name">
        <span v-html="label"></span>
      </label>

      <div v-if="isPasswordType">
        <input :id="name"
              :name="name"
              :type="inputType"
              :validation-name="validationName"
              autocomplete=""
              :maxlength="maxlength"
              class="form-control"
              ref="input"
              v-model="currentValue"
              :disabled="disabled"
              :data-cy="cypressName"
              @input="onInput"
              @blur="onBlur"
              @focus="onFocus"
              @change="onChange"
              @animationstart="checkAnimation" />
        <i v-if="showEyeIcon"
          @click.prevent="switchCharacters()"
          @keydown.enter="switchCharacters()"
          :title="$t(visibleCharacters ? 'general.clickToHidePassword' : 'general.clickToShowPassword')"
          class="icon"
          :class="visibleCharacters? 'eye-close' : 'eye-open'"
          tabindex="0"
          :aria-label="visibleCharacters? 'Passwort verbergen' : 'Passwort anzeigen'"
          role="img"
          >
        </i>

      </div>

      <input v-if="!isPasswordType"
            :id="name"
            :name="name"
            :type="inputType"
            :validation-name="validationName"
            :autocomplete="autocomplete"
            :maxlength="maxlength"
            :placeholder="placeholder"
            class="form-control"
            :class="{'pdf-input': pdfInput}"
            ref="input"
            v-model="currentValue"
            :disabled="disabled"
            :data-cy="cypressName"
            @input="onInput"
            @blur="onBlur"
            @focus="onFocus"
            @change="onChange"
            @animationstart="checkAnimation" />

      <cso-info-icon v-if="hint && !isPasswordType"
                    :content="hint" />
    </div>

    <div class="cso-input-errors-wrapper"
         v-if="validationErrors && showValidationErrors">
      <div v-for="(error, index) in validationErrors"
           class="cso-input-error"
           v-html="error.message"
           :key="index">
      </div>
    </div>

  </div>
</template>
<script>
import validatedInputField from '@/mixins/validatedInputField'

import CsoInfoIcon from '@/components/core/composition/CsoInfoIcon.vue'

export default {
  name: 'CsoInput',
  mixins: [validatedInputField],
  components: {
    CsoInfoIcon
  },
  props: {
    maxlength: {
      type: String,
      required: false
    },
    pattern: {
      type: [String, RegExp],
      required: false
    },
    autocomplete: {
      type: String,
      required: false
    },
    showEyeIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isLowerCase: {
      type: Boolean,
      required: false,
      default: false
    },
    isErrorMessage: {
      type: Boolean,
      required: false,
      default: false
    },
    cypressName: {
      type: String,
      required: false
    },
    pdfInput: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visibleCharacters: false,
      patternRegex: null,
      isActive: false,
      autofilled: false,
      isFilled: false
    }
  },

  computed: {
    isPasswordType: function () {
      return this.type === 'password'
    },

    inputType: function () {
      if (!this.isPasswordType) {
        return 'text'
      } else {
        return this.visibleCharacters ? 'text' : 'password'
      }
    }
  },

  watch: {
    currentValue: function (newValue, oldValue) {
      if (!!newValue && this.type === 'number') {
        this.currentValue = newValue.replaceAll(/\./g, ',')
      } else {
        this.currentValue = newValue
      }
      this.setFilled()
    }
  },

  methods: {
    onInput ($event) {
      // hack to force immediate update of the model - on Android mobiles while inputing text vue waits until the space is clicked to trigger update: https://github.com/vuejs/vue/issues/9777
      this.currentValue = $event.target.value
      this.currentValue = (this.type === 'number') ? this.currentValue.replace(',', '.') : this.currentValue

      if (!!this.patternRegex && !!this.currentValue && !this.patternRegex.test(this.currentValue)) {
        this.currentValue = this.modelValue
        return
      }
      this.currentValue = this.isLowerCase ? this.currentValue.toLowerCase() : this.currentValue

      this.$emit('update:modelValue', this.currentValue.trim())
    },

    onBlur (e) {
      this.isActive = false

      this.$emit('blur', e)
    },

    onFocus (e) {
      this.isActive = true

      this.$emit('focus', e)
    },

    onChange (e) {
      this.$emit('change', e)
    },

    setFilled () {
      this.isFilled = this.currentValue !== ''
    },

    switchCharacters () {
      this.visibleCharacters = !this.visibleCharacters
    },

    checkAnimation (e) {
      if (e && e.animationName === 'onAutoFillStart') {
        this.autofilled = true
      } else if (e && e.animationName === 'onAutoFillCancel') {
        this.autofilled = false
      }
    }
  },

  created: function () {
    if (this.pattern) {
      this.patternRegex = new RegExp(this.pattern)
    }
  },

  mounted: function () {
    this.setFilled()
  }
}
</script>

<style lang="scss">
@import "./CsoInput";
</style>
